import { render, staticRenderFns } from "./UpdateRecordDetail.vue?vue&type=template&id=32223a80&scoped=true&"
import script from "./UpdateRecordDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./update-request-detail.css?vue&type=style&index=0&id=32223a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32223a80",
  null
  
)

export default component.exports